// Module
var code = "<title>Customily Retail Install</title> <div style=\"min-height:100%\" ng-controller=\"RetailCtrl\"></div> ";
// Exports
module.exports = code;